import { Component, registerComponent } from "aframe";
import { AnimationMap } from "./avatar";


export interface SlotAnimationsComponent extends Component
{
	data : AnimationMap;
}

const trim = (str : string) => str.trim();
const parseSlotAnimations = (value : any) =>
{
	if( typeof value == "string" )
	{
		const result : AnimationMap = {};
		for(let x of value.split(";"))
		{
			const ix = x.indexOf(":");
			if(ix <= 0) continue; //Need a non empty regex filter key
			const key = x.slice(0, ix).trim();
			
			let val = x.slice(ix+1).trim(), filter = "";
			if(val.startsWith("/"))
			{
				const endIx = val.lastIndexOf("/");
				filter = val.slice(1, endIx);
				val = val.slice(endIx+1);
			}
			result[key] = { filter, clips : val.split(",").map(trim) }
		}
		return result;
	}
	return value;
};

const stringifySlotAnimations = (value : AnimationMap) =>
{
	let result = "", sep = "";
	for(let key in value)
	{
		const val = value[key];
		result += sep + key + ":";
		if(val.filter) result += "/" + val.filter + "/";
		result += val.clips.join(",");
	}
};

registerComponent("slot-animations", {
	multiple : true,
	schema : {
		default : {},
		parse: parseSlotAnimations,
		stringify : stringifySlotAnimations
	}
})